export default class HedgingConfiguration {
    miniContractMinOfferQuantities: number[] = null;
    fullContractMinOfferQuantities: number[] = null;
}